export const PDFstyle = {
    page: {
        flexDirection: 'column',
        backgroundColor: 'white',
        padding: 10,
    },
    mainSection: {
        marginTop: 20,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    headerSection: {
        marginBottom: 10,
    },
    addressSection: {
        flexDirection: 'column',
        width: '50%',
        padding: 5,
    },
    labelSection: {
        flexDirection: 'column',
        width: '50%',
        padding: 5,
        transform: 'rotate(270deg)',
        transformOrigin: 'top right',
        position: 'absolute',
        right: 0,
        top: 0,
    },
    adSection: {
        marginTop: 20,
        marginRight: 10,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    bottomSection: {
        position: 'absolute',
        bottom: 20,
        left: 10,
        right: 10,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    text: {
        fontSize: 10,
        lineHeight: '16px',
        fontFamily: 'Helvetica',
    },
    text2: {
        fontSize: 12,
        lineHeight: '16px',
        fontFamily: 'Helvetica',
    },
    boldText: {
        fontSize: 10,
        fontFamily: 'Helvetica-Bold',
    },
    largeText: {
        fontSize: 24,
        fontFamily: 'Helvetica-Bold',
    },
    smallText: {
        fontSize: 8,
        fontFamily: 'Helvetica',
    },
    verticalText: {
        transform: 'rotate(270deg)',
        transformOrigin: 'center',
    },
    afzenderSection: {
        margin: 12,
        lineHeight: '14px',
    },
    trackingNumber: {
        marginTop: 5,
        textAlign: 'center',
    },
    avgBox: {
        position: 'absolute',
        left: 350,
        bottom: 60,
        textAlign: 'center',
    },
    rotatedAddressLabel: {
        position: 'absolute',
        right: 90,
        top: 150,
        transform: 'rotate(270deg)',
        transformOrigin: 'top right',
    },
    signatureBox: {
        position: 'absolute',
        left: 10,
        bottom: 60,
        width: 150,
    },
    handtekeningText: {
        fontSize: 8,
        marginBottom: 2,
    },
    signatureLine: {
        borderBottom: '1pt solid black',
        width: 120,
        marginTop: 20,
    },
    collo: {
        position: 'absolute',
        left: 350,
        bottom: 120,
    },
    middleHeaderSection: {
        position: 'absolute',
        top: 12,
        left: '50%',
        transform: 'translateX(-60%)'
    },
    addressBox: {
        marginLeft: 'auto',
        marginRight: '16px',
        border: '1px solid black',
        padding: '6px',
        height: '120px',
        width: '225px'
    },
    barcodeSection: {
        marginTop: 20,
        width: '100%',
        alignItems: 'center', // Center the barcode
    },
    barcode: {
        height: 40,
        width: 200, // Set explicit width
    },
    addressTextSection: {
        marginLeft: 'auto',
        marginRight: '16px',
        marginBottom: '2px',
        width: '225px'
    },
    addressText: {
        fontSize: '12px',
        lineHeight: '16px',
        fontFamily: 'Helvetica'
    },
    AVGtext: {
        fontSize: '12px',
        fontFamily: 'Helvetica',
        marginLeft: 'auto'
    },
    colloBox: {
        marginLeft: 'auto',
        marginRight: '16px',
        marginTop: '2px',
        width: '225px'
    },
    collo: {
        fontSize: '12px',
        fontFamily: 'Helvetica',
        marginLeft: 'auto'
    }
}